export default {
  setApiUrl(state, payload) {
    state.apiUrl = payload.apiUrl;
  },
  setAppConfig(state, payload) {
    state.appVersion = payload.appVersion;
    state.config = payload.config;
  },
  setConfigHasBeenRead(state) {
    state.configHasBeenRead = true;
  },
  setMemberExists(state, payload) {
    state.memberExists = payload;
  },
  setQuestions(state, payload) {
    state.questions = payload;
  },
  setPlayerLevels(state, payload) {
    state.playerLevels = payload;
  },
  setRankings(state, payload) {
    state.rankings = payload;
  },
  setPlayerMoments(state, payload) {
    state.playerMoments = payload;
  },
  setRegistered(state, payload) {
    state.registered = payload;
  },
};
